/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

const { Grid } = require("@material-ui/core");

const ContentLayout = ({ style, children }) => {
	return (
		<Grid container item justifyContent="flex-start" style={{ maxWidth: 1200, marginTop: 30, ...style }}>
			{children}
		</Grid>
	);
};

const PanelContainer = ({ children, spacing = 3, ...props }) => {
	return (
		<Grid spacing={spacing} container {...props}>
			{children}
		</Grid>
	);
};

const LeftPanelLayout = ({ cols = 4, children, ...props }) => {
	return (
		<Grid item xs={cols} {...props}>
			{children}
		</Grid>
	);
};

const RightPanelLayout = ({ cols = 8, children, ...props }) => {
	return (
		<Grid item xs={cols} {...props}>
			{children}
		</Grid>
	);
};

export { ContentLayout, LeftPanelLayout, RightPanelLayout, PanelContainer };
